import React, { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import Loader from "../../components/common/Loader";
import { FaTrash } from "react-icons/fa";
import WelcomeCard from "../../components/common/WelcomeCard";

const InquiryPage = () => {
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch all inquiries
  const fetchInquiries = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/inquiry/get-all-inquiries`);
      const data = Array.isArray(res.data.data) ? res.data.data : [];
      setInquiries(data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load inquiries");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInquiries();
  }, []);

  // Delete inquiry
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this inquiry?")) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/inquiry/delete-inquiry/${id}`);
      setInquiries(prev => prev.filter(i => i._id !== id));
      toast.success("Inquiry deleted successfully");
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete inquiry");
    }
  };

  // Format date for display
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleString("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  };

  return (
    <div className="p-4">
       <WelcomeCard />
      <h1 className="text-xl font-semibold mb-4">All Inquiries</h1>
      
      {loading ? (
        <div className="flex justify-center items-center mt-10"><Loader /></div>
      ) : inquiries.length === 0 ? (
        <div className="text-center text-gray-500 mt-10">No inquiries found</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full border rounded">
            <thead>
              <tr className="bg-gray-100">
                <th className="py-2 px-4 border">Date</th>
                <th className="py-2 px-4 border">Name</th>
                <th className="py-2 px-4 border">Email</th>
                <th className="py-2 px-4 border">Phone</th>
                <th className="py-2 px-4 border">Service</th>
                <th className="py-2 px-4 border">City</th>
                <th className="py-2 px-4 border">State</th>
                <th className="py-2 px-4 border">Message</th>
                <th className="py-2 px-4 border">Actions</th>
              </tr>
            </thead>
            <tbody>
              {inquiries.map((inq) => (
                <tr key={inq._id} className="hover:bg-gray-50">
                  <td className="py-2 px-4 border whitespace-nowrap">{formatDate(inq.createdAt)}</td>
                  <td className="py-2 px-4 border">{inq.name}</td>
                  <td className="py-2 px-4 border">{inq.email}</td>
                  <td className="py-2 px-4 border">{inq.phone}</td>
                  <td className="py-2 px-4 border">{inq.service}</td>
                  <td className="py-2 px-4 border">{inq.city || "-"}</td>
                  <td className="py-2 px-4 border">{inq.state || "-"}</td>
                  <td className="py-2 px-4 border">{inq.message}</td>
                  <td className="py-2 px-4 border text-center">
                    <button 
                      onClick={() => handleDelete(inq._id)} 
                      className="text-red-500 hover:text-red-700"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default InquiryPage;